import { createFileRoute } from "@tanstack/react-router"

import { EditorialIndex } from "@/components/content-display"
import { getPublicContentFn } from "@/lib/app.functions"

export const Route = createFileRoute("/news")({
  loader: () => getPublicContentFn({ data: { kind: "news" } }),
  head: () => ({
    meta: [{ title: "Field notes · Harbor & Pine Realty" }],
  }),
  component: NewsPage,
})

function NewsPage() {
  return (
    <EditorialIndex
      eyebrow="Editorial desk"
      title="Field notes"
      intro="Practical, synthetic editorial content showing how market guidance, listing education, and commercial checklists live beside the catalogue."
      items={Route.useLoaderData()}
      kind="news"
    />
  )
}
